import { api } from "@/infrastructure/api";
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as A from "./actions";
import * as T from "./types";
import { AxiosResponse } from "axios";


export function* fetchDashboardMeta() {
  try {
    const { data }: AxiosResponse<T.DashboardMeta> = yield call(
      api.get,
      `/dashboard/dashboard-meta`
    );

    yield put(A.fetchDashboardMeta.success(data));
  } catch (e) {
    yield put(A.fetchDashboardMeta.failure());
  }
}


export function* fetchBenchmarkAnalysis({ payload }: ReturnType<typeof A.fetchBenchmarkAnalysis.request>) {
  try {
    const { data }: AxiosResponse<T.BenchmarkAnalysis> = yield call(
      api.get,
      `/dashboard/benchmark-analysis/${payload}`
    );

    yield put(A.fetchBenchmarkAnalysis.success({exchange: payload, data}));
  } catch (e) {
    yield put(A.fetchBenchmarkAnalysis.failure());
  }
}

export function* fetchSectorIndustryPerf() {
  try {
    const { data }: AxiosResponse<T.Performance> = yield call(api.get, `/dashboard/sector-industry`);

    yield put(A.fetchSectorIndustryPerf.success(data));
  } catch (e) {
    yield put(A.fetchSectorIndustryPerf.failure());
  }
}

export default function*() {
  yield all([
    takeLatest(A.fetchDashboardMeta.request, fetchDashboardMeta),
    takeLatest(A.fetchBenchmarkAnalysis.request, fetchBenchmarkAnalysis),
    takeLatest(A.fetchSectorIndustryPerf.request, fetchSectorIndustryPerf),
  ]);
}
